import { Navigate } from '@comet/router';
import { FC } from 'react';

const Dashboard: FC = () => {
  return <Navigate routeId="organisations" replace />;
};

export default Dashboard;
